/**
 * @typedef {{key: string, forced: boolean, additionalConsentKeys: string[]}} StorageEntry
 */

let cookieContainer = null;
let container = null;
let cookieContainerSettings = null;
/** @type {string[]} */
const allStorages = [];
/** @type {string[]} */
const forcedStorages = [];
/** @type {Map<string, StorageEntry>} */
const storageData = new Map();

window.dataLayer = window.dataLayer || [];

$(document).ready(function () {

    container = $('#c3kieContainerSettings');
    cookieContainer = $('.cookie-container');
    cookieContainerSettings = $('.cookie-container-settings');

    /** @type {StorageEntry[]} */
    const storagesData = JSON.parse(container[0].dataset.storages);
    for (const storage of storagesData) {
        storageData.set(storage.key, storage);
        allStorages.push(storage.key);
        if (storage.forced) {
            forcedStorages.push(storage.key);
        }
    }

    // migrate old cookie value to new one.
    const cookieValue = getCookie('c3kie');
    if (cookieValue) {
        if (cookieValue.startsWith('save-settings')) {
            eraseCookie('c3kie');
        }
        if (cookieValue.startsWith('accept-all')) {
            eraseCookie('c3kie');
            selectStorages(allStorages);
        }
        if (cookieValue.startsWith('revoke') || cookieValue.startsWith('notice')) {
            eraseCookie('c3kie');
            selectStorages(forcedStorages);
        }
    }

    checkCookieLifetime();
    showCookieWindow();
    setCookieHeight();

    const defaultGtagData = {};
    for (const storage of allStorages) {
        const keys = [`${storage}_storage`, ...storageData.get(storage).additionalConsentKeys];
        for (const key of keys) {
            defaultGtagData[key] = 'denied';
        }
    }

    gtag('consent', 'default', defaultGtagData);

    /**
     * cookies revoked
     */
    $('.cookie-outer-container-wrap .revoke').click(function () {
        selectStorages(forcedStorages);
        allStorages.forEach(storage => {
            localStorage.removeItem('c3kie_' + storage);
        });
        cookieContainerSettings.hide();
        cookieContainer.hide();
        submitCookieSettings();
        location.reload();
    });

    /**
     * load cookies after button accept
     */
    $('.cookie-outer-container-wrap .accept-all').click(function () {
        allStorages.forEach(storage => {
            localStorage.setItem('c3kie_' + storage, 'true');
        });
        selectStorages(allStorages);
        cookieContainerSettings.hide();
        cookieContainer.hide();
        preSelectSettings();
        loadCookieScripts();
        submitCookieSettings();
        location.reload();
    });

    /**
     * load cookies - show only hint
     */
    $('.cookie-outer-container-wrap .notice').click(function () {
        selectStorages(forcedStorages);
        cookieContainer.hide();
    });
    if ($('.cookie-container.optin_0').length && localStorage.getItem('cookie_optin') !== 'true') {
        localStorage.setItem('cookie_optin', 'true');
        allStorages.forEach(storage => {
            localStorage.setItem('c3kie_' + storage, 'true');
        });
    }

    /**
     * save cookie settings
     */
    $('.cookie-outer-container-wrap .save-settings').click(function () {
        cookieContainerSettings.hide();
        cookieContainer.hide();
        if (checkCookieLifetime()) {
            eraseCookie(checkCookieLifetime());
        }
        const cookies = [];
        allStorages.forEach(storage => {
            localStorage.removeItem('c3kie_' + storage);
            if ($(`.cookie-option[data-name="${storage}"]`).is(':checked')) {
                localStorage.setItem('c3kie_' + storage, 'true');
                cookies.push(storage);
            }
        });

        selectStorages(cookies);
        loadCookieScripts();
        submitCookieSettings();
        location.reload();
    });

    preSelectSettings();
    placeCookieSettings();
    loadCookieScripts();
    analyze();

    /**
     * open cookie settings
     */
    $('.cookie-outer-container-wrap .settings').click(function () {
        cookieContainerSettings.show();
    });

    /**
     * edit cookie settings - privacy page
     */
    $('.cookie-settings-button').click(function () {
        preSelectSettings();
        cookieContainerSettings.show();
    });

    /**
     * close cookie option window
     */
    cookieContainerSettings.click(function (e) {
        if (!$(this)
            .parents('.cookie-container-popup').length && $(e.target)[0].className === 'inner-cookie-container-settings') {
            cookieContainerSettings.hide();
        }
    });

    /**
     * close / show cookie description window
     */
    $('.cookie-description-container-open').click(function () {
        $('.cookie-description-container').show();
    });
    $('.cookie-description-container-window-inner-close').click(function () {
        $('.cookie-description-container').hide();
    });

    /**
     * youtube-video-disclaimer
     */
    let youtubePlayButton = $('.youtube-activate-button');
    if (youtubePlayButton !== undefined && youtubePlayButton.length) {

        youtubePlayButton.unbind('click');
        youtubePlayButton.click(function () {

            convertIntoYoutubeElement($(this), 1);

        });

        /**
         * automatic remove youtube-video-disclaimer if opt-in accepted
         */
        if (storageIsAccepted('functionality')) {
            youtubePlayButton.each(function () {
                convertIntoYoutubeElement($(this), 0);
            });
        }
    }
    let vimeoPlayButton = $('.vimeo-activate-button');
    if (vimeoPlayButton !== undefined && vimeoPlayButton.length) {
        vimeoPlayButton.unbind('click');
        vimeoPlayButton.click(function () {
            convertIntoVimeoElement($(this), 1);
        });

        /**
         * automatic remove youtube-video-disclaimer if opt-in accepted
         */
        if (storageIsAccepted('youtube')) {
            vimeoPlayButton.each(function () {
                convertIntoVimeoElement($(this), 0);
            });
        }
    }

});

$(window).resize(function () {
    setCookieHeight();
});


function convertIntoYoutubeElement(element, autoplay) {
    const parentElement = element.parent();
    const mainElement = parentElement.parent();
    const imgElement = parentElement.find('.preview-image');

    let width = imgElement.width();
    let height = imgElement.height();
    let youtube_src = element.data('youtube-src');
    let uid = element.data('uid');

    const videoElement = $('<iframe id="youtube-video-' + uid + '" class="youtube-video" width="' + width + '" height="' + height + '"\n' + 'src="https://www.youtube-nocookie.com/embed/' + youtube_src + '?enablejsapi=1&autoplay=' + autoplay + '&rel=0&modestbranding=1"\n' + ' allowfullscreen allow="autoplay; encrypted-media"></iframe>');

    mainElement.append(videoElement);
    parentElement.remove();
}

function convertIntoVimeoElement(element) {
    const parentElement = element.parent();
    const mainElement = parentElement.parent();
    const imgElement = parentElement.find('.preview-image');

    let width = imgElement.width();
    let height = imgElement.height();
    let vimeo_src = element.data('vimeo-src');
    let uid = element.data('uid');

    const videoElement = $('<iframe id="vimeo-video-' + uid + '" class="vimeo-video" width="' + width + '" height="' + height + '"\n' + 'src="https://player.vimeo.com/video/' + vimeo_src + '"\n' + ' allowfullscreen allow="autoplay; encrypted-media"></iframe>');

    mainElement.append(videoElement);
    parentElement.remove();
}

/**
 * load cookies on page load
 */
function loadCookieScripts() {
    const gtagData = {};
    const storages = getSelectedStorages();
    for (const storageKey of storages) {
        const keys = [`${storageKey}_storage`, ...storageData.get(storageKey).additionalConsentKeys];
        for (const key of keys) {
            gtagData[key] = 'granted';
        }
    }

    gtag('consent', 'update', gtagData);

    let valuesArray = [];

    container.find('[type="checkbox"]:checked').each(function (key, value) {
        valuesArray.push($(value).data('name'));
    });

    container.find('#values').val(valuesArray.toString());

    const url = new URL(container.attr('action'), location);

    const newUrl = new URL(`${url.origin}${url.pathname}`);
    if (url.searchParams.get('id')) {
        newUrl.searchParams.append('id', url.searchParams.get('id'));
    }
    newUrl.searchParams.append('type', url.searchParams.get('type'));
    newUrl.searchParams.append('tx_c3cookie_ajax[controller]', 'Ajax');
    newUrl.searchParams.append('tx_c3cookie_ajax[action]', 'cookieScriptContainer');
    newUrl.searchParams.append('cHash', url.searchParams.get('cHash'));

    $.ajax({
        method: 'POST',
        url: newUrl,
        data: {
            'tx_c3cookie_ajax[storages]': JSON.stringify(storages)
        }
    })
        .done(function (msg) {
            $('head').append(msg);
        });
}

function submitCookieSettings() {
    const url = new URL(container.attr('action'), location);
    const newUrl = new URL(`${url.origin}${url.pathname}`);
    newUrl.searchParams.set('type', '1613380');

    let values = {
        data: getCookieData()
    };
    if (navigator.language) {
        values.browser_language = navigator.language;
    }
    if (document.querySelector('#cookie-fe-language')) {
        values.website_language = document.querySelector('#cookie-fe-language').value;
    }

    $.ajax({
        method: 'POST',
        url: newUrl,
        data: {
            'tx_c3cookie_ajax[controller]': 'Ajax',
            'tx_c3cookie_ajax[action]': 'cookieSubmit',
            'tx_c3cookie_ajax[values]': JSON.stringify(values)
        }
    });
}

function analyze() {

    let values = {};
    if (navigator.language) {
        values.browser_language = navigator.language;
    }
    if (document.querySelector('#cookie-fe-language')) {
        values.website_language = document.querySelector('#cookie-fe-language').value;
    }

    values.browser = {};
    values.browser.userAgent = ((navigator.userAgent) ? navigator.userAgent : '');
    values.browser.cookieEnabled = ((navigator.cookieEnabled) ? navigator.cookieEnabled : '');
    values.browser.maxTouchPoints = ((navigator.maxTouchPoints) ? navigator.maxTouchPoints : '');

    values.device = {};
    values.device.innerWidth = ((window.innerWidth) ? window.innerWidth : '');
    values.device.innerHeight = ((window.innerHeight) ? window.innerHeight : '');
    values.device.outerWidth = ((window.outerWidth) ? window.outerWidth : '');
    values.device.outerHeight = ((window.outerHeight) ? window.outerHeight : '');
    values.device.devicePixelRatio = ((window.devicePixelRatio) ? window.devicePixelRatio : '');

    values.info = {};
    values.info.url = ((window.location.href) ? window.location.href : '');
    values.info.referrer = ((document.referrer) ? document.referrer : '');

    values.info.hash = getCookieData()?.token ?? null;

    values.storages = getSelectedStorages();

    const url = new URL(container.data('tracking'), location);
    const newUrl = new URL(`${url.origin}${url.pathname}`);

    if (url.searchParams.get('id')) {
        newUrl.searchParams.append('id', url.searchParams.get('id'));
    }
    newUrl.searchParams.append('type', url.searchParams.get('type'));
    newUrl.searchParams.append('tx_c3cookie_ajax[controller]', 'Ajax');
    newUrl.searchParams.append('tx_c3cookie_ajax[action]', 'analyze');
    newUrl.searchParams.append('cHash', url.searchParams.get('cHash'));

    $.ajax({
        method: 'POST',
        url: newUrl,
        data: {
            'tx_c3cookie_ajax[values]': JSON.stringify(values)
        }
    });
}

function setCookieHeight() {
    if (cookieContainer != null) {
        if (cookieContainer.hasClass('top') || cookieContainer.hasClass('bottom')) {
            if (cookieContainer.hasClass('bottom')) {
                document.body.style.paddingBottom = cookieContainer.outerHeight() + 'px';
            }
            if (cookieContainer.hasClass('top')) {
                if (cookieContainer.css('position') === 'fixed') {
                    document.body.style.paddingTop = '0px';
                } else {
                    document.body.style.paddingTop = cookieContainer.outerHeight() + 'px';
                }
            }
        }
    }
}

/**
 * set checkboxes on user input
 * preselect in settings window
 */
function preSelectSettings() {
    allStorages.forEach(storage => {
        if (storageIsAccepted(storage)) {
            $(`.cookie-option[data-name="${storage}"]:not([disabled])`).prop('checked', true);
        }
    });
}

/**
 * display the cookie window
 */
function showCookieWindow() {
    if (!checkCookieLifetime()) {
        cookieContainer[0]?.style?.setProperty('display', 'block');
        let popup = $('.cookie-outer-container-wrap.popup');
        if (popup.length && !popup.hasClass('.privacy-page')) {
            popup.find('.cookie-container-settings').show();
        }
    } else {
        cookieContainer.hide();
    }
}

/**
 * place cookie settings button on privacy page
 */
function placeCookieSettings() {
    let customSettingsBox = $('.c3kie-custom-cookie-settings-position');

    if (customSettingsBox.length) {
        placeCookieButton(customSettingsBox);
    } else {
        $('.cookie-settings-default-button').show();
    }
}

/**
 * append edit cookie button into an element
 * @param {jQuery} elem
 */
function placeCookieButton(elem) {
    elem.append($('.cookie-outer-container-wrap'));
}

/**
 * create hash value
 * @param {number} length
 * @returns {string}
 */
function createRandomString(length) {
    let result = '';
    const characters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

/**
 *
 * @returns {{token: string, storages: string[]}|null}
 */
function getCookieData() {
    const cookie = getCookie('c3kie');
    if (!cookie) {
        return null;
    }
    try {
        return JSON.parse(cookie);
    } catch (_) {
    }
    return null;
}

/**
 * which action was performed
 * @param {string[]} storages
 */
function selectStorages(storages) {
    const data = getCookieData();

    setCookie(
        'c3kie',
        JSON.stringify({
            token: data?.token ?? createRandomString(64),
            storages
        }),
        '180'
    );
}

/**
 *
 * @returns {string[]}
 */
function getSelectedStorages() {
    return getCookieData()?.storages ?? [];
}

/**
 *
 * @param {string} storage
 * @returns {boolean}
 */
function storageIsAccepted(storage) {
    return getSelectedStorages().includes(storage);
}

window.c3cookie = {
    getCookieData,
    selectStorages,
    getSelectedStorages,
    storageIsAccepted
};

function checkCookieLifetime() {
    let c3kie = getCookie('c3kie');
    if (c3kie === null) {
        allStorages.forEach(storage => {
            localStorage.removeItem('c3kie_' + storage);
        });
        return false;
    }
    return c3kie;
}

/**
 * create cookie
 * @param {string} name
 * @param {string} value
 * @param {string} days
 */
function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }

    const hostParts = location.host.split('.');
    const domain = [hostParts[hostParts.length - 2], hostParts[hostParts.length - 1]].join('.');

    document.cookie = `${name}=${value || ''}${expires}; secure; path=/; domain=${domain}`;
}

/**
 * read cookie
 * @param {string} name
 * @returns {null|string}
 */
function getCookie(name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

/**
 * remove cookie
 * @param {string} name
 */
function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function gtag() {
    dataLayer.push(arguments);
}
